import { render, staticRenderFns } from "./goodSupplierlist.vue?vue&type=template&id=37a173fd&scoped=true&"
import script from "./goodSupplierlist.vue?vue&type=script&lang=js&"
export * from "./goodSupplierlist.vue?vue&type=script&lang=js&"
import style0 from "./goodSupplierlist.vue?vue&type=style&index=0&id=37a173fd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a173fd",
  null
  
)

export default component.exports